// Normaliza el campo `incluido` de una entidad/ítem (booleano, 1/0 o undefined).
export const esIncluido = (valor) => valor === true || valor === 1;